








































































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import * as Moment from 'moment';
import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';
import FacilityData from '@/ts/FacilityData';
import { defaultBlockDuration } from '@/ts/store/constants/SharedFacilities';
import { extendMoment } from 'moment-range';
import DateMethods from '@/mixins/DateMethods.vue';
import cloneDeep from 'lodash/cloneDeep';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import ObjectHelper from '@/mixins/ObjectHelper.vue';

const moment = extendMoment(Moment);

@Component
export default class BookFacilityTimeOverlay extends Mixins(DateMethods, NotifyMethods, ObjectHelper) {
    public selectedTimes: any = [];
    public facilityHours: any = [];

    constructor() {
        super();
    }

    get date() {
        return this.$store.getters['SharedFacilities/getFacilityBookingDate'];
    }

    get facility(): FacilityData {
        return this.$store.getters['SharedFacilities/getUserSelectedFacility'];
    }

    get unavailabilityTimes(): any {
        return this.$store.getters['SharedFacilities/getSharedFacilityUnavailabilityTimes'];
    }

    get duration(): string {
        let blockDuration: number;
        let totalDuration: number;

        const selectedSlots = this.selectedTimes.length;

        blockDuration = this.facility.hasHourlyBookingOption ? defaultBlockDuration : this.safeObjProperty(this.facility, 'block.duration', 60);
        totalDuration = blockDuration * selectedSlots;

        const formattedDuration = moment.utc(moment.duration(totalDuration, 'minutes').asMilliseconds()).format('H m');
        const durationsArr  = formattedDuration.split(' ');
        const hours         = Number(durationsArr[0]);
        const minutes       = Number(durationsArr[1]);

        switch (true) {
            case hours === 0 && minutes === 0:
                return `0`;
            case hours > 0 && minutes === 0:
                return `${hours}${this.$t('general.hour-shortcut', 'h')}`;
            case hours > 0 && minutes > 0:
                return `${hours}${this.$t('general.hour-shortcut', 'h')} ${minutes}${this.$t('general.minute-shortcut', 'm')}`;
            case hours === 0 && minutes > 0:
                return `${minutes}${this.$t('general.minute-shortcut', 'm')}`;
        }

    }

    get startTime(): any {
        return minBy(this.selectedTimes, 'blockIndex');
    }

    get endTime(): any {
        return this.selectedTimes.length > 1 ? maxBy(this.selectedTimes, 'blockIndex') : undefined;
    }

    public createBlockRange(block: string) {
        const blockDuration = !this.facility.hasBlockBookingOption ? defaultBlockDuration : this.safeObjProperty(this.facility, 'block.duration', 60);

        const blockStartTime = moment.utc(block, 'YYYY-MM-DD HH:mm:ss');
        const blockEndTime   = blockStartTime.clone().add(blockDuration, 'm');

        if (blockEndTime.clone().format('HH:mm') === '00:00') {
            blockEndTime.subtract(1, 'second');
        }

        return `${blockStartTime.format('HH:mm')} - ${blockEndTime.format('HH:mm')}`;
    }

    public commitTime() {
        const blockDuration = !this.facility.hasBlockBookingOption ? defaultBlockDuration : this.safeObjProperty(this.facility, 'block.duration', 60);
        const nextDayBegin  = moment.utc(this.date, 'DD-MM-YYYY').add(1, 'days').startOf('day');

        const startTime = moment.utc(this.startTime.block, 'YYYY-MM-DD HH:mm:ss');

        let endTime = typeof this.endTime === 'undefined'
            ? startTime.clone().add(blockDuration, 'm')
            : moment.utc(this.endTime.block, 'YYYY-MM-DD HH:mm:ss').add(blockDuration, 'm');

        if (endTime.isSame(moment.utc(nextDayBegin))) {
            endTime = moment.utc(this.date, 'DD-MM-YYYY').endOf('day');
        }

        this.$store.commit(Mutations.SET_FACILITY_BOOKING_TIME, {
            startTime: startTime.format('hh:mm A'),
            endTime: moment.utc(endTime).format('hh:mm A'),
        });

        this.cancel();
    }

    public selectRange(selectedTime: any = null): void {
        if (this.selectedTimes.length > 1) {
            const startTime = this.startTime;
            const endTime   = this.endTime;

            if (endTime.blockIndex - startTime.blockIndex > 1) {
                for (const time of this.facilityHours) {
                    if (
                        time.blockIndex < endTime.blockIndex &&
                        time.blockIndex > startTime.blockIndex &&
                        time.status !== 'selected' &&
                        selectedTime.status === 'selected' &&
                        time.status !== 'disabled' &&
                        time.status !== 'booked' &&
                        time.status !== 'time_passed'
                    ) {
                        time.status = 'selected';
                        this.selectedTimes.push(time);
                    }
                }
            }
        }
    }

    public saveTime(selectedTime: any) {
        if (selectedTime.status === 'disabled' || selectedTime.status === 'booked' || selectedTime.status === 'time_passed') {
            return;
        }

        // Check if admin make max bookable slots as 0
        if (this.facility.hasBlockBookingOption && this.facility.block.maxBookableBlocks === 0) {
            return this.showMaxBookingsError();
        }

        // Check if there are any disabled times between and limits
        if (this.selectedTimes.length > 0 && selectedTime.status === 'available') {
            const startTime     = selectedTime.blockIndex < this.startTime.blockIndex ? selectedTime : this.startTime;
            const endTime       = (typeof this.endTime !== 'undefined' && selectedTime.blockIndex < this.endTime.blockIndex) ? this.endTime : selectedTime;
            const disabledTimes = [];

            if (this.facility.hasBlockBookingOption) {
                const selectedBlocksCount = (endTime.blockIndex - startTime.blockIndex) + 1;

                if (this.facility.block.maxBookableBlocks < selectedBlocksCount) {
                    return this.showMaxBookingsError();
                }
            }

            for (const time of this.facilityHours) {
                if (
                    (time.status === 'disabled' || time.status === 'booked' || time.status === 'time_passed') &&
                    (time.blockIndex > startTime.blockIndex && time.blockIndex < endTime.blockIndex)
                ) {
                    disabledTimes.push(time);
                }
            }

            if (disabledTimes.length) {
                return;
            }
        }

        // Deselect the first one
        if (this.selectedTimes.length > 1 && selectedTime.blockIndex === this.startTime.blockIndex) {
            selectedTime.status = 'available';
            this.selectedTimes = this.selectedTimes.filter((time: any) => time.blockIndex !== selectedTime.blockIndex);
            return;
        }

        // Deselect the selected hour (with range)
        if (selectedTime.status === 'selected') {
            selectedTime.status = 'available';
            this.selectedTimes = this.selectedTimes.filter((time: any) => {
                return time.blockIndex < selectedTime.blockIndex;
            });

            this.facilityHours.forEach((value: any, index: number) => {
                if (index > selectedTime.blockIndex && value.status !== 'disabled' && value.status !== 'booked' && value.status !== 'time_passed') {
                    value.status = 'available';
                }
            });
        } else {
            // Select the selected hours range
            selectedTime.status = 'selected';
            this.selectedTimes.push(selectedTime);
            this.selectRange(selectedTime);
        }
    }

    public scrollToTime(index: number) {
        const element = document.getElementById('hoc-facility-booking-time-' + index);

        if (element) {
            element.scrollIntoView();
        }
    }

    public showMaxBookingsError() {
        const duration        = this.safeObjProperty(this.facility, 'block.duration', 60) * this.facility.block.maxBookableBlocks;
        const durationInHours = duration / 60;

        const text = !Number.isInteger(durationInHours)
            ? `${duration} ${this.$t('general.minutes', 'Minutes')}`
            : durationInHours > 1 ? `${durationInHours} ${this.$t('general.hours', 'Hours')}` : `${durationInHours} ${this.$t('general.hour', 'Hour')}`;

        return this.notify(
            'max_bookings',
            'primary-notify',
            text,
            3000,
            'top',
        );
    }

    public cancel() {
        this.facilityHours = [];
        this.$store.commit(Mutations.SET_BOOK_FACILITY_TIME_OVERLAY_VISIBILITY, false);
    }

    public created() {
        this.facilityHours = cloneDeep(this.unavailabilityTimes);
    }

    public mounted() {
        this.scrollToTime(7);
    }

    public updated() {
        this.$store.commit(Mutations.SET_FACILITY_BOOKING_DURATION, this.duration);
    }
}
